export const publications = [
  {
    title: "IdeaLens: Detecting AI Ideas in Long-form Writing",
    authors: ["Rishanth Rajendhran", "Minjoon Choi", "Jenna Russel", "Ramya Namuduri", "Deniz Bölöni-Turgut", "Marzena Karpinska", "John Wieting", "Mohit Iyyer"],
    conf: "Preprint",
    id: "arXiv:2610.06778",
    link: "https://arxiv.org/abs/2610.06778",
    github: "https://github.com/RishanthRajendhran/IdeaLens",
    date: "2026-10-6"
  },
  {
    title: "POLARIS: Guiding Small Models to Write Long Stories",
    authors: ["Rishanth Rajendhran", "Jenna Russel", "Mohit Iyyer", "John Wieting"],
    conf: "EMNLP Main Conference 2026",
    id: "arXiv:2606.04095",
    link: "https://arxiv.org/abs/2606.04095",
    github: "https://github.com/RishanthRajendhran/POLARIS",
    date: "2026-6-2"
  },
  {
    title: "StoryScope: Investigating idiosyncrasies in AI fiction",
    authors: ["Jenna Russel", "Rishanth Rajendhran", "Chau Minh Pham", "Mohit Iyyer", "John Wieting"],
    conf: "COLM 2026",
    id: "arXiv:2604.03136",
    link: "https://arxiv.org/abs/2604.03136",
    github: "https://github.com/jenna-russell/storyscope",
    date: "2026-4-13"
  },
  {
    title: "VeriFastScore: Speeding up long-form factuality evaluation",
    authors: ["Rishanth Rajendhran","Amir Zadeh","Matthew Sarte","Chuan Li", "Mohit Iyyer"],
    conf: "Findings of EMNLP 2025",
    id: "arXiv:2505.16973",
    link: "https://arxiv.org/abs/2505.16973",
    github: "https://github.com/RishanthRajendhran/VeriFastScore",
    date: "2025-5-22"
  },
  {
    title: "Whispers of Doubt Amidst Echoes of Triumph in NLP Robustness",
    authors: ["Ashim Gupta","Rishanth Rajendhran","Nathan Stringham","Vivek Srikumar","Ana Marasović"],
    conf: "NAACL 2024",
    id: "arXiv:2311.09694",
    link: "https://arxiv.org/abs/2311.09694",
    github: "https://github.com/RishanthRajendhran/robustnessEvaluation",
    date: "2023-11-20"
  }
];